import React, {useEffect, useRef} from 'react';
import {Animated, Easing, Image} from 'react-native';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import Div from 'lib/Div';
import depositSuccessGlow from 'assets/img/deposit-success-glow.png';
import {styles} from '../styles';

const resultPopEase = Easing.bezier(0.2, 0.8, 0.2, 1);

const useDepositSuccessIconAnimation = () => {
  const iconProgress = useRef(new Animated.Value(0)).current;
  const burstProgress = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    let mounted = true;
    let burstDelay: ReturnType<typeof setTimeout> | undefined;

    Animated.timing(iconProgress, {toValue: 1, duration: 360, easing: resultPopEase, useNativeDriver: true}).start();

    const runBurst = () => {
      burstProgress.setValue(0);
      Animated.timing(burstProgress, {
        toValue: 1, duration: 2400, easing: Easing.out(Easing.ease), useNativeDriver: false
      }).start(({finished}) => {
        if (finished && mounted) runBurst();
      });
    };

    burstDelay = setTimeout(runBurst, 500);

    return () => {
      mounted = false;
      if (burstDelay) clearTimeout(burstDelay);
      iconProgress.stopAnimation();
      burstProgress.stopAnimation();
    };
  }, [burstProgress, iconProgress]);

  return {
    burstStyle: {
      opacity: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [0.45, 0, 0]}),
      width: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [80, 124, 80]}),
      height: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [80, 124, 80]}),
      marginLeft: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [-40, -62, -40]}),
      marginTop: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [-40, -62, -40]}),
      borderRadius: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [40, 62, 40]}),
      borderWidth: burstProgress.interpolate({inputRange: [0, 0.7, 1], outputRange: [0, 22, 0]})
    },
    iconStyle: {
      opacity: iconProgress.interpolate({inputRange: [0, 0.6, 1], outputRange: [0, 1, 1]}),
      transform: [{scale: iconProgress.interpolate({inputRange: [0, 0.6, 1], outputRange: [0.7, 1.05, 1]})}]
    }
  };
};

const DepositSuccessIcon = () => {
  const {burstStyle, iconStyle} = useDepositSuccessIconAnimation();

  return (
    <Div alignItems="center" mt={16} position="relative">
      <Div pointerEvents="none" style={styles.depositSuccessGlowImage}>
        <Image source={depositSuccessGlow as any} resizeMode="contain" style={styles.depositSuccessGlowFill}/>
      </Div>

      <Animated.View pointerEvents="none" style={[styles.depositSuccessBurst, burstStyle]}/>

      <Animated.View style={[styles.depositSuccessIconLayer, iconStyle]}>
        <Div w={80} h={80} rounded={999} bg="rgba(39,233,166,0.16)" borderWidth={1}
             borderColor="rgba(39, 233, 166, 0.2)" alignItems="center" justifyContent="center">
          <MaterialIcons name="check-circle" size={44} color="#27e9a6"/>
        </Div>
      </Animated.View>
    </Div>
  );
};

export default DepositSuccessIcon;
